import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Input from '../../components/ui/Input.jsx';
import { customersApiService } from '../../services';

function Folder({ tabColors = { bgcolor: 'bg-purple-300', nocolor: 'bg-purple-100', hovercolor: 'hover:bg-purple-200' } }) {
  const { id } = useParams();
  const [, setTicket] = useState(null);

  useEffect(() => {
    if (id) {
      customersApiService.getTicketById(id)
        .then(async data => {
          setTicket(data);

          // Fetch fresh customer data to avoid stale cached names
          let customerName = data.customer_name;
          try {
            const customer = await customersApiService.getCustomerByNumber(data.customer_number);
            if (customer && customer.customer_name) {
              customerName = customer.customer_name;
            }
          } catch (err) {
            console.warn('Could not fetch fresh customer data, using cached name:', err);
          }

          const pageTitle = `${data.ticket_number} - ${customerName} - ${data.issue_with}`;
          document.title = pageTitle;
        })
        .catch(err => {
          console.error('Error fetching ticket:', err);
          document.title = 'SSK - Support Swiss Knife';
        });
    } else {
      document.title = 'SSK - Support Swiss Knife';
    }

    return () => {
      document.title = 'SSK - Support Swiss Knife';
    };
  }, [id]);

  const [inputs, setInputs] = useState({
    customerFolderName: ' - ',
    customerFolderPath: 'Z:/ - /',
    TKTFolderName: ' - ',
    TKTSubFolderName: 'Z:/ - / - /',
  });

  // Consultando datos de la bd
  useEffect(() => {
    if (!id) return;

    customersApiService.getTicketById(id)
      .then(async ticket => {
        // Fetch fresh customer data to avoid stale cached names
        let customerName = ticket.customer_name;
        try {
          const customer = await customersApiService.getCustomerByNumber(ticket.customer_number);
          if (customer && customer.customer_name) {
            customerName = customer.customer_name;
          }
        } catch (err) {
          console.warn('Could not fetch fresh customer data, using cached name:', err);
        }

        setInputs({
          customerFolderName: `${ticket.customer_number} - ${customerName}`,
          customerFolderPath: `Z:/${ticket.ticket_number} - ${customerName}/`,
          TKTFolderName: `${ticket.ticket_number} - ${ticket.issue_with}`,
          TKTSubFolderName: `Z:/${ticket.customer_number} - ${customerName}/${ticket.ticket_number} - ${ticket.issue_with}/`,
        });
      })
      .catch(err => console.error('Error fetching ticket:', err));
  }, [id]);

  const copyToClipboard = id => {
    const inputValue = inputs[id];
    navigator.clipboard.writeText(inputValue).then(() => {
      const messageElement = document.getElementById(`${id}-message`);
      if (messageElement) {
        messageElement.textContent = 'Copied to clipboard!';
        messageElement.classList.remove('hidden');
        setTimeout(() => {
          messageElement.textContent = '';
          messageElement.classList.add('hidden');
        }, 2000); // Limpia el mensaje después de 2 segundos
      }
    });
  };

  const createFolder = async () => {
    const folderName = 'NuevaCarpeta'; // Cambia el nombre según lo que necesites

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/create-folder`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ folderName }),
      }
    );

    const data = await response.json();
    alert(data.message || data.error);
  };

  return (
    <div className='h-screen grid grid-cols-2 grid-rows-5 gap-4 items-center p-8'>
      <div className="bg-yellow-400 w-1/3 h-auto p-6 rounded-lg border border-yellow-600 ">
        <h1 className="pb-2 font-semibold text-xl">
          New local folder creation
        </h1>
        <button
          onClick={createFolder}
          className="px-2 py-1 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            style={{ width: '1.5rem', height: '1.5rem', paddingRight: '5px' }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 10.5v6m3-3H9m4.06-7.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
            />
          </svg>
          Create new Folder
        </button>
      </div>

      <div className="bg-slate-100 rounded-xl border-2 border-yellow-600 p-6 row-start-2">
        <div>
          <h1 className="pb-2 font-semibold text-xl">Customer folder name:</h1>
          <div className="flex">
            <Input
              id="customerFolderName"
              type="text"
              value={inputs.customerFolderName}
              placeholder=""
              className="text-yellow-600 font-semibold text-xl items-center"
              readOnly
            />
            <button
              onClick={() => copyToClipboard('customerFolderName')}
              className="px-2 py-1 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                style={{ width: '1.5rem', height: '1.5rem' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                />
              </svg>
              Copy to Clipboard
            </button>
          </div>
          <p
            id="customerFolderName-message"
            className="message bg-green-500 text-white mt-2 p-2 inline-block rounded-2xl hidden"
          ></p>
        </div>
      </div>

      <div className="bg-slate-100 rounded-xl border-2 border-yellow-600 p-6 row-start-2">
        <div>
          <h1 className="pb-2 font-semibold text-xl">
            TKT & ISSUE SUB-folder name:
          </h1>
          <div className="flex">
            <Input
              id="TKTFolderName"
              type="text"
              value={inputs.TKTFolderName}
              placeholder=""
              className="text-yellow-600 font-semibold text-xl items-center"
              readOnly
            />
            <button
              onClick={() => copyToClipboard('TKTFolderName')}
              className="px-2 py-1 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                style={{ width: '1.5rem', height: '1.5rem' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                />
              </svg>
              Copy to Clipboard
            </button>
          </div>
          <p
            id="TKTFolderName-message"
            className="message bg-green-500 text-white mt-2 p-2 inline-block rounded-2xl hidden"
          ></p>
        </div>
      </div>

      <div className="bg-slate-100 rounded-xl border-2 border-yellow-600 p-6 row-start-3">
        <div>
          <h1 className="pb-2 font-semibold text-xl">Customer folder Path:</h1>
          <div className="flex">
            <Input
              id="customerFolderPath"
              type="text"
              value={inputs.customerFolderPath}
              placeholder=""
              className="text-yellow-600 font-semibold text-xl items-center"
              readOnly
            />
            <button
              onClick={() => copyToClipboard('customerFolderPath')}
              className="px-2 py-1 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                style={{ width: '1.5rem', height: '1.5rem' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                />
              </svg>
              Copy to Clipboard
            </button>
          </div>
          <p
            id="customerFolderPath-message"
            className="message bg-green-500 text-white mt-2 p-2 inline-block rounded-2xl hidden"
          ></p>
        </div>
      </div>

      <div className="bg-slate-100 rounded-xl border-2 border-yellow-600 p-6 row-start-3">
        <div>
          <h1 className="pb-2 font-semibold text-xl">
            Ticket SUB-folder Path:
          </h1>
          <div className="flex">
            <Input
              id="TKTSubFolderName"
              type="text"
              value={inputs.TKTSubFolderName}
              placeholder=""
              className="text-yellow-600 font-semibold text-xl items-center"
              readOnly
            />
            <button
              onClick={() => copyToClipboard('TKTSubFolderName')}
              className="px-2 py-1 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                style={{ width: '1.5rem', height: '1.5rem' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                />
              </svg>
              Copy to Clipboard
            </button>
          </div>
          <p
            id="TKTSubFolderName-message"
            className="message bg-green-500 text-white mt-2 p-2 inline-block rounded-2xl hidden"
          ></p>
        </div>
      </div>
    </div>
  );
}

export default Folder;
